/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { FlagType, MessageType, OriginType, RaceProgressionData, RunType, SeriesType } from 'models/viewModels';

export const defaultRaceProgressionValue: RaceProgressionData = {
  lapNumber: 0,
  totalLaps: 0,
  flag: FlagType.UNKNOWNFLAGTYPE,
  localTime: 0,
  timeElapsed: 0,
  greenLapsFlagCount: 0,
  yellowLapsFlagCount: 0,
  totalStages: 0,
  currentStage: 0,
  currentStageCurrentLap: 0,
  currentStageTotalLaps: 0,
  timeRemaining: 0,
  sessionInfo: {
    eventId: '',
    runType: RunType.UNKNOWNRUNTYPE,
    seriesId: '',
    eventName: '',
    feedSpecificRunName: '',
    seriesType: SeriesType.UNKNOWN,
    clientId: '',
    originType: OriginType.UNKNOWN,
  },
  messageInfo: {
    messageType: MessageType.RACE_PROGRESSION,
    originType: OriginType.UNKNOWN,
  },
};
